module.exports = __webpack_public_path__ + "img/block-1920.a1669bd4.jpg";